import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    states: [
        "Backlog",
        "Ready",
        "Doing",
        "Review",
        "Blocked",
        "Done"
    ],
    searchText: ""
};

const projectSlice = createSlice({
    name: "projects",
    initialState,
    reducers: {
        setSearchText: (state, action) => {
            state.searchText = action.payload;
        }
    },
});

export const { setSearchText } = projectSlice.actions;
export default projectSlice.reducer;
